// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><path d=\"M8.5 8.5l15 15M23.5 8.5l-15 15\" stroke=\"%23090d11\" stroke-width=\"4.6\" stroke-linecap=\"round\" opacity=\"0.76\"/><path d=\"M8.5 8.5l15 15M23.5 8.5l-15 15\" stroke=\"%23ec736a\" stroke-width=\"2.45\" stroke-linecap=\"round\"/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><path d=\"M16 7v18M7 16h18\" stroke=\"%23090d11\" stroke-width=\"4.6\" stroke-linecap=\"round\" opacity=\"0.76\"/><path d=\"M16 7v18M7 16h18\" stroke=\"%2349c97c\" stroke-width=\"2.45\" stroke-linecap=\"round\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chain-space {
    height: 100%;
    width: 100%;
    /* 1px left the first row's 1px outline flush with the scroll edge, where
       fractional-DPR rounding clips it; the 2px vertical inset gives it
       headroom. Horizontal content uses the same 20px frame as the header
       CTA and device editor (Gosta, round 6). */
    padding: 2px 20px;
}

.chain-space:not(.empty) {
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: start;
    align-items: flex-start;
}

.chain-space.empty {
    display: flex;
    text-align: center;
    align-items: center;
    flex-direction: column;
}

.chain-space.empty .empty {
    padding: 50px;
    color: var(--black-45);
    font-style: italic;
}

.chain-matrix {
    display: flex;
    width: fit-content;
    margin-left: 34px;
}

.chain-box {
    /* same 320px frame as browser rows: one left/right edge per panel */
    position: relative;
    display: flex;
    height: 40px;
    width: 320px;
    align-items: center;
    overflow: visible;
    /* Figma user-color formula: 20% fill, 30% on hover (Colors page frame 492) */
    background-color: color-mix(in srgb, var(--chain-color, var(--black-30)) 20%, transparent);
    box-shadow: 0 0 4px var(--black-05);
}

.chain-box > .overlay {
    position:absolute;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    left: 50%;
    top: 50%;
    background: #000000AA;
    z-index: 999;
}

.chain-box > .overlay > h1 {
    color: var(--black-65);
    font-size: 17px;
    margin: 1px;
    white-space: nowrap;
    text-align: center;
}

.chain-box > .overlay > h2 {
    color: var(--black-45);
    margin: 0px;
    font-size: 13px;
    font-style: italic;
    text-align: center;
}

.chain-box:hover {
    outline: 1px solid var(--black-25);
    outline-offset: -1px;
    background-color: color-mix(in srgb, var(--chain-color, var(--black-30)) 30%, transparent);
}

.chain-box.hidden  {
    background-color: var(--black-10);
}

.chain-box.highlight {
    outline: 1px solid var(--black-35);
    outline-offset: -1px;
    box-shadow: 0 0 2px var(--black-35);
}

.chain-box .activate {
    margin: 10px;
    height: 16px;
    width: 16px;
}

.chain-box .activate .button {
    position: absolute;
    border-radius: 18px;
    border: 3px solid;
    height: 18px;
    width: 18px;

    border-color: var(--black-30);
    background-color: var(--black-00);

    user-select: none; 
}

.chain-box .activate .button.invalid::before {
    color: var(--black-30);
    position: relative;
    bottom: 8px;
    left: -8px;
    font-size: 28px;
    font-weight: bold;
    content: 'remove';
    font-family: 'Material Icons';
}

.chain-box .activate .button.invalid,
.chain-box .activate:hover .button.invalid {
    filter: none;
}

.chain-box .name {
    position: relative;
    width: 150px;
    letter-spacing: 0;

    font-size: 13px;
    font-weight: 500;

    white-space: nowrap;
    overflow: hidden;
    mask: linear-gradient(to right, black 80%, transparent 100%);

    line-height: 2;

    user-select: none; 
}

.chain-box .name.edit {
    background-color: var(--black_10);
    color: var(--black-80);
    border: var(--black-80) solid 1px;
    padding-left: 2px;
    padding-right: 2px;
    text-overflow: clip;
    mask: none;
}

.chain-box .hide {
    position: absolute;
    right: 108px;
    color: var(--black-35);
}

.chain-box .normal {
    position: absolute;
    right: 68px;
    font-size: 23px;
    color: var(--black-35);
}

.chain-box .normal.active {
    font-weight: bold;
}

.chain-box .fave {
    font-size: 24px;
    position: absolute;
    right: 32px;
    color: var(--black-35);
}

.chain-box .lock {
    font-size: 16px;
    margin-left: 4px;
    opacity: 0.7;
    cursor: pointer;
}
.chain-box .lock:hover { opacity: 1; }

.chain-box .popup {
    position: absolute;
    right: 1%;
    font-size: 22px;
    top: 7px;
}

.chain-box .div {
    position: absolute;
    right: 97px;
    background-color: var(--black-35);
    top: 7px;
    height: 26px;
    width: 1px;
    opacity: 30%;
}

.color-picker {
    border-top: 2px solid var(--black-30);
    height: auto;
    padding-top: 12px;
    margin-bottom: 6px;
}

/* Even 4-per-row distribution across the menu width, no trailing gap */
.color-picker .swatches {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    justify-items: center;
    row-gap: 12px;
}

.color-picker .swatch {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    cursor: pointer;
    transition: transform 100ms ease;
}

.color-picker .swatch:hover {
    transform: scale(1.15);
}

/* Selection = neutral outline ring around the (still round) swatch */
.color-picker .swatch.selected {
    outline: 2px solid var(--black-85);
    outline-offset: 2px;
}

.chain-header {
    position: relative;
    align-items: center;
    width: 100%;
    user-select: none;
    font-size: 24px;
    z-index: 1;

}

.chain-header .header {
    position: relative;
    width: 100%;
    /* Figma chain header: 12px left, 8px right, 4px gap (node 16:1542) */
    padding: 0 8px 0 12px;
    gap: 4px;

    height: 32px;

    display: flex;
    justify-content: left;
    align-items: center;

    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
}

.chain-header.active .header {
    color: var(--black-65);
}

.chain-header.muted .mutable {
    filter: brightness(0.4);
}

.chain-header.muted .header .mutable:hover {
    filter: brightness(0.8);
}

.chain-header .header .activate {
    position: relative;

    /* Figma bypass hit box is 28x28; centers the dot on the same 26px axis
       as the subheader target icon (component 2307:65100) */
    width: 28px;
    height: 28px;

    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
}

.chain-header .header .activate .button {
    height: 18px;
    width: 18px;
    border-radius: 18px;
    border: 3px solid;
    border-color: var(--black-30);
    background-color: var(--black-00);
}

/* Center the 'remove' bar on the ring with flex instead of the old
   hand-tuned bottom/left offsets that left it visibly off-axis */
.chain-header .header .activate .button.invalid {
    display: flex;
    justify-content: center;
    align-items: center;
}

.chain-header .header .activate .button.invalid::before {
    color: var(--black-30);
    font-size: 28px;
    font-weight: bold;
    line-height: 1;
    content: 'remove';
    font-family: 'Material Icons';
}

.chain-header .header .activate .button.invalid,
.chain-header .header .activate:hover .button.invalid {
    filter: none;
}

.chain-header .header .activate .button.midi-learn::after {
    height: 20px;
    width: 20px;
    border-radius: 16px;
}

/* An ON chain uses the same hover lift as other circular controls. */
.chain-header .header .activate.active .button:hover,
.chain-box.active .activate .button:not(.invalid):hover {
    filter: brightness(1.3);
}

/* An OFF chain dims the ring to the same 60% as the header title, so it stops
   reading as active. Ring stays brighter than the fill (Gosta, July 20).
   Same treatment in the chain browser box, so the toggle looks identical in
   both panels */
.chain-header:not(.active) .header .activate .button:not(.invalid):not(.midi-learn),
.chain-box.inactive .activate .button:not(.invalid):not(.midi-learn) {
    opacity: 0.6;
}

.chain-header:not(.active) .header .activate:hover .button:not(.invalid):not(.midi-learn),
.chain-box.inactive .activate:hover .button:not(.invalid):not(.midi-learn) {
    opacity: 1;
}

/* 4px margin + 4px header gap = Figma's 8px bypass-to-name gap; the auto
   right margin pushes the controls to the right edge (node 16:1542) */
.chain-header .header .editable.name {
    margin-left: 4px;
    margin-right: auto;
    min-width: 0;
}

.chain-header .header .editable.name  .name {
    position: relative;
    width: 236px;

    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.02em;

    white-space: nowrap;
    overflow: hidden;
    mask: linear-gradient(to right, black 70%, transparent 100%);
}

.chain-header .editable.name .name.edit {
    background-color: var(--black_10);
    color: var(--black-85);
    border: var(--black-65) solid 1px;
    padding-right: 2px;
    text-overflow: clip;
    mask: none;
    opacity: 1;
}

.chain-header.split .header .editable.name  .name {
    width: 480px;
}

.chain-header .lock {
    font-size: 18px;
    opacity: 0.7;
    cursor: pointer;
}
.chain-header .lock:hover { opacity: 1; }

.chain-header .minimize {
    font-size: 24px;
}

/* Figma header controls: 24px glyph + 2px padding = 28px hit box (node 16:1542) */
.chain-header .header .acticon {
    padding: 2px;
}

.chain-header .header .tridot {
    line-height: 1;
}

/* Figma dims the inactive header to 60%; the active chain shows full color
   (component 16:1542, active vs default variants) */
.chain-header:not(.active) .header .editable.name .name:not(.edit),
.chain-header:not(.active) .header .minimize,
.chain-header:not(.active) .header .popup {
    opacity: 0.6;
}

.chain-header .header .minimize:hover,
.chain-header .header .popup:hover {
    opacity: 1;
}

.chain-header .target {
    opacity: 0.8;
    /* center the 18px icon on the bypass toggle's axis (measured 433 in the
       demo): subheader pads 12px, so 12 + 4 + 9 lands the centers together */
    margin-left: 4px;
    font-size: 24px;
    color: var(--black-35);
}

.chain-header .acticon.selected {
    color: var(--hover-fg);
}

.chain-header .subheader {
    width: 100%;
    /* Figma subheader: 24px icons + 8px vertical padding (node 3463:60728) */
    height: 40px;
    /* Figma subheader padding (node 3463:60728) */
    padding: 0 12px;
    box-sizing: border-box;

    color: var(--black-35);
    display: flex;
    justify-content: space-between;
}

.chain-header .chain-tags {
    margin-left: 34px;
    margin-right: 16px;
    margin-bottom: 12px;
}

.chain-header .subheader > .left {
    display: flex;
    text-align: center;
    justify-content: left;
    align-items: center;
}

.chain-header .subheader > .right {
    display: flex;
    text-align: center;
    justify-content: right;
    align-items: center;
}

.chain-header .normal {
    font-size: 24px;
    /* Figma "N" glyph is Roboto Condensed (node 3463:60728); falls back to Inter
       until the font ships in fonts/gfonts.css */
    font-family: 'Roboto Condensed', 'Inter', sans-serif;
}

.chain-header .normal.active {
    font-weight: bold;
}

.chain-header .notes {
    margin-left: 14px;
}

.chain-header .subheader .tags {
    margin-left: 8px;
    /* Figma sell glyph is 20px, the other subheader icons 24px */
    font-size: 20px;
}

.chain-header .fave {
    margin-left: 8px;

    font-size: 24px;
}

/* CHAIN BLOCK */

.chain-module {
    position: relative;
    width: 276px;
    /* Figma chain slot block is 37px (node 16:1665) */
    height: 37px;

    color: var(--black-85);
    border-radius: 2px;

    display: flex;
    user-select: none;
}

/* Smooth transitions for dimming when overlay is visible */
.chain-module .frame,
.chain-module .tab,
.chain-module > * {
    transition: opacity 120ms ease, filter 120ms ease;
}

/* Dim underlying content while keeping overlay crisp */
.chain-module.overlay > *:not(.portid),
.browser-module.overlay > *:not(.portid) {
    opacity: 0.55;
    filter: saturate(0.7) brightness(0.95);
}

/* PortID badge */
.portid {
    top: 0%;
    right: 54px;
    padding: 3px;
    padding-right: 5px;
    transform: translateY(32%);

    display: flex;
    position: absolute;
    justify-content: center;
    align-items: center;

    color: var(--black-00);
    font-size: 12px;
    white-space: nowrap;

    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.25);
    background: var(--black-15);

    pointer-events: none;
    z-index: 2;
}

.right > .portid {
    right: 51px;
}

.conjoined .portid {
    right: 80px;
}

.stereo .portid  {
    right: 100px;
}

.m2s .portid {
    right: 70px;
}

/* PorID badge role-specific */
.portid.dest { 
    background: var(--black-00);
    border: 0.8px solid var(--black-65);
    color: var(--black-80);
    padding-bottom: 4px;
    padding-top: 4px;
}
.portid.source {
    background: var(--black-80);
    border: 2px solid var(--black-05);
}
.portid.proc {
    transform: translateY(22%);
    background: var(--black-35);
    padding-bottom: 6px;
    padding-top: 6px;
}

/* PortID token */
.portid.proc .in,
.portid.proc .out {
    margin: 0 3px;
    padding: 0 2px;
    border-radius: 3px;
    border: none;
    background: transparent;
}

.portid div {
    margin: 0px;
    margin-left: 2px;
    padding: 0px;
    border: none;
    background: transparent;
}

/* PortID polarity-specific */
.portid.proc .in {
    background: var(--black-85);
    color: var(--black-00);
}
.portid.proc .out {
    background: var(--black-00);
    color: var(--black-80);
}

.chain-module .device  {
    position: absolute;
    left: 14.5px;
    top: 3px;
    width: 210px;
    letter-spacing: 0.02em;

    font-size: 13px;
    font-weight: 700;
    color: var(--black-80);

    white-space: nowrap;
    overflow: hidden;
    mask: linear-gradient(to right, black 80%, transparent 100%);
}

.chain-module.invalid .device,
.chain-module.invalid .name {
    font-style: italic;
    color: var(--black-45);
}

.chain-module.stereo .device,
.chain-module.m2s .device {
    width: 190px;
}

.chain-module.conjoined .device {
    width: 240px;
}

.chain-module .name {
    position: absolute;
    bottom: 3px;
    left: 15px;
    width: 210px;

    font-size: 13px;
    color: var(--black-80);

    white-space: nowrap;
    overflow: hidden;
    mask: linear-gradient(to right, black 80%, transparent 100%);
}

.chain-module.conjoined .name {
    width: 240px;
}

.chain-module.stereo .name {
    width: 190px;
}

.chain-module.m2s .name {
    width: 205px;
}

.chain-module .frame {
    position: absolute;
    height: 100%;
    width: 276px;
    left: 0px;

    background-color: var(--black-25);

    display: flex;
    justify-content: center;
    align-items: center;
}

/* A node in a chain is picked up and dropped, so it reacts to the pointer. The
   module itself has no background, the frame paints it. Scoped to .chain-cell:
   the same markup illustrates a device's shape in the configuration panel,
   where it is read-only. */
.chain-cell .chain-module:hover .frame {
    background-image: linear-gradient(var(--hover-veil), var(--hover-veil));
}

/* A conjoined stereo node is rendered as two modules in a split cell, but both
   halves are dragged as one item. Hover either rendered half as one node too. */
.chain-cell.split:has(.chain-module.conjoined:hover) .chain-module.conjoined .frame {
    background-image: linear-gradient(var(--hover-veil), var(--hover-veil));
}

.chain-module.invalid .frame {
    background: var(--red-1);
}

.chain-module.ineligible {
    color: var(--black-45);
    opacity: 30%;
}

.chain-card.drop-invalid .chain-module .frame {
    color: var(--black-45);
}

.chain-module .stub {
    width: 100%;

    font-size: 13px;
    font-style: italic;
    color: var(--black-45);

    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    user-select: none;
}

.chain-module .bypass {
    height: 18px;
    width: 18px;

    position: absolute;
    left: 10px;

    font-size: 22px;

    border-radius: 16px;

    cursor: pointer;
    user-select: none; 
}

.chain-module.inactive .bypass {
    height: 18px;
    width: 18px;

    border-color: var(--black-80);
    border-radius: 10px;
    border-width: 3px;
}

.chain-module .popup {
    position: absolute;
    right: 1px;
    top: 6px;
    font-size: 22px;
}

.chain-module .channel {
    /* Figma channel badge is a 22px circle, 12px bold (node 16:615) */
    border-radius: 22px;
    position: absolute;
    height: 22px;
    width: 22px;
    right: 24px;

    font-size: 12px;
    font-weight: 700;

    color: var(--black-85);
    background-color: var(--black-35);

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 2px var(--black-05);
}

.chain-module .channel.inactive {
    color: var(--black-65);
    background-color: var(--black-20);
    font-weight: 500;
}

/* Only the bypass toggle reacts. The same .channel markup renders a read-only
   mono/stereo badge in the device configuration, which must stay inert. */
.chain-module .channel.acticon:hover {
    filter: brightness(1.3);
}

.chain-module .channel.bypassed {
    color: var(--black-05);
    background-color: var(--black-45);
    font-weight: 500;
}

.chain-module .channel.stereo.L {
    right: 51px;
}

.chain-module .channel.m2s {
    font-size: 12.5px;
    width: 42px;
}

/* the chain header's 24px line box already seats the ink on center — undo
   the global .tridot ink nudge there (it is tuned for 22.8px line boxes) */
.chain-header .header .tridot {
    top: 0;
}

.chain-module.selected .frame {
    outline-color: var(--black-65);
    outline-width: 1px;
    outline-offset: -1px;
    outline-style: solid;
}

/* AB groups */

.chain-module.grouped .tab {
    position: relative;
    height: 100%;
    width: 20px;
    left: -24px;
    padding-left: 1px;

    background-color: var(--black-25);

    font-size: 16px;
    font-weight: bold;
    color: var(--black-65);

    cursor: pointer;
    user-select: none;
}

.chain-module.grouped .tab > .index {
    height: 100%;
    width: 100%;

    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.chain-module.grouped .tab > .index.midi-learn::after {
    height: 110%;
    width: 120%;
}

.chain-module.grouped .tab.active {
    color: var(--black-05);
    background-color: var(--black-45);
}

.chain-module.grouped .tab.bypassed {
    color: var(--black-05);
    background-color: var(--black-30);
}

.chain-module.grouped.top .tab {
    border-top-left-radius: 12px;
}

.chain-module.grouped.top .tab > .index {
    border-top-left-radius: 12px;
}

.chain-module.grouped.top .tab > .index.midi-learn::after {
    border-top-left-radius: 12px;
}

.chain-module.grouped.bottom .tab {
    border-bottom-left-radius: 12px;
}

.chain-module.grouped.bottom .tab > .index {
    border-bottom-left-radius: 12px;
}

.chain-module.grouped.bottom .tab > .index.midi-learn::after {
    border-bottom-left-radius: 12px;
}

/* PROC TAB */
.chain-module.grouped.proc .tab { 
    background-color: var(--node-bg);
}

.chain-module.grouped.proc .tab.active {
    background-color: var(--black-45);
}

.chain-module.grouped.proc .tab.bypassed {
    background-color: var(--black-30);
}

.chain-module.grouped.ab-focus .frame {
    background-color: #7a746b;
    box-shadow:
        inset 0 0 0 1px rgba(237, 226, 209, 0.12),
        inset 0 0 0 999px rgba(205, 181, 145, 0.05);
}

.chain-module.grouped.ab-focus .tab {
    background-color: #877968;
}

.chain-module.grouped.ab-focus::after {
    --ab-focus-border: rgba(216, 194, 162, 0.44);
    content: '';
    position: absolute;
    left: -27px;
    top: -3px;
    width: 302px;
    height: 41px;
    border-left: 2px dashed var(--ab-focus-border);
    border-right: 2px dashed var(--ab-focus-border);  
    pointer-events: none;
    z-index: 2;
}

.chain-module.grouped.ab-focus.top::after {
    border-top: 2px dashed var(--ab-focus-border);
    border-top-left-radius: 14px;
    border-top-right-radius: 4px;
}

.chain-module.grouped.ab-focus.bottom::after {
    border-bottom: 2px dashed var(--ab-focus-border);
    border-bottom-left-radius: 14px;
    border-bottom-right-radius: 4px;
}

.chain-module.source.grouped.ab-focus.top::after {
    border-top-right-radius: 14px;
}

.chain-module.dest.grouped.ab-focus.bottom::after {
    border-bottom-right-radius: 14px;
}

.chain-module.grouped.ab-focus.left::after {
    width: 581px;
}

.chain-module.grouped.ab-focus.right::after {
    content: none;
}

.chain-cell:not(.split).replace-outline .chain-module .frame {
    outline: 1px solid var(--black-90);
    outline-offset: -1px;
}

.chain-module.grouped.replace-target .frame,
.chain-cell.split.replace-outline.replace-channel.left .chain-module.left .frame,
.chain-cell.split.replace-outline.replace-channel.right .chain-module.right .frame {
    /* Gosta (round 6): the drop ring is a 1px line inside the rectangle */
    outline: 1px solid var(--black-90);
    outline-offset: -1px;
}

.chain-module.grouped.replace-target .frame.left,
.chain-cell.split.replace-outline.replace-channel.left .chain-module.left .frame.left {
    clip-path: inset(-2px 0 -2px -2px);
}

.chain-module.grouped.replace-target .frame.right,
.chain-cell.split.replace-outline.replace-channel.right .chain-module.right .frame.right {
    clip-path: inset(-2px -2px -2px 0);
}

/* A whole split replacement is one visual target. Drawing outlines on both
   child frames exposes their internal seam (and clipping those frames also
   clips their backgrounds), so use one non-destructive overlay rectangle. */
.chain-cell.split.replace-outline:not(.replace-channel)::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: calc(2 * 276px + 3px);
    height: 37px;
    outline: 1px solid var(--black-90);
    outline-offset: -1px;
    pointer-events: none;
    z-index: 4;
}

.chain-module.dragging .frame {
    box-shadow: 0 0 8px rgba(0,0,0,0.4);
}

.chain-module.dragging.conjoined .frame.left {
    clip-path: inset(-8px 0 -8px -8px); /* clips right side only */
}

.chain-module.dragging.conjoined .frame.right {
    clip-path: inset(-8px -8px -8px 0); /* clips left side only */
}

.chain-module.conjoined .frame.right .buffer {
    width: 65%;
    position: absolute;
    left: 0px;
    height: 100%;
}

/* SOURCE */
.chain-module.source .frame {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
}

.chain-module.stub .frame {
    background-color: var(--black-10);
}

.chain-module.stub.proc .frame {
    background-color:  var(--black-10);
}

.chain-module.source.grouped .frame {
    border-radius: 0;
}

.chain-module.source.grouped.top .frame {
    border-top-right-radius: 12px;
}

/* DESTINATION */
.chain-module.dest .frame {
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
}

.chain-module.dest.grouped .frame {
    border-radius: 0;
}

.chain-module.dest.grouped.bottom .frame {
    border-bottom-right-radius: 12px;
}

.chain-module.dest.grouped.bottom.left .frame {
    border-bottom-right-radius: 0px;
}

 /* PROCESSOR */
.chain-module.proc .frame {
    background-color: var(--node-bg);
    border-radius: 0;
}

.chain-module.proc.invalid .frame {
    background: var(--red-1);
}

/* SPLIT */
.chain-module.left .frame {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
}

.chain-module.right .frame {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    left: 2px;
}

.chain-module.right.conjoined .frame {
    left: 0px;
    width: 278px;
}

.chain-module.grouped.top.left .frame {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
}

/* BLANK */
.chain-blank {
    width: 345px;
    height: 52px;
}

.chain-cell-bridge {
    position: relative;
    left: 0px;
    top: -2px;
    width: calc(-1px + 276px);
    height: calc(2px + 41px);
    overflow:hidden;
    display: flex;
}

.chain-cell-bridge .link {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 20.5px;
    left: -133px;
    border-radius: 12px;
    border: 2px solid #e7d8d9;
}

.chain-cell-bridge .tee {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 20.5px;
    border-top: 2px solid #e7d8d9;
}

.chain-cell-bridge .thru {
    position: absolute;
    width: 100%;
    height: 100%;
    left: -133px;
    border-right: 2px solid #e7d8d9;
}

.chain-cell {
    /* insert-line color, AB/group context: the coffee of the AB outlines
       (Gosta, round 6). The old pocket-pill palette is gone — one variable
       drives every insert indicator. */
    --slot-pocket-edge: rgba(244, 208, 159, 0.88);
    position: relative;
    width: 314px;
    /* Figma chain column: 37px slot + 4px gap (node 16:1664) */
    height: 41px;
    overflow: visible;
    display: flex;
}

/* Gosta (round 6): the regular insert line is white like every other line
   (mult lines, drag targets — #e7d8d9); only the AB/group context keeps the
   coffee color above. Blue is gone. */
.chain-cell.slot-outer {
    --slot-pocket-edge: rgba(231, 216, 217, 0.92);
}

.chain-cell.split {
    width: 592px;
}

/* DND */
.chain-cell > .dz {
    position: absolute;
    z-index:3;
    width: 276px;
}

.chain-cell > .dz.split {
    width: calc(2 * 276px);
}

.dz.top {
    position: absolute;
    height: 20px;
    top: -12px;
}

.dz.mid {
    position: absolute;
    top: 10px;
    height: 26px;
}

.dz.bot {
    position: absolute;
    height: 20x;
    bottom: -15px;
}

.dz.top-overlay {
    display: none;
    position: absolute;
    /* Gosta (round 6): a plain line at the mult-line weight (2px, the value
       that survives strong zoom-out) — the gradient pocket pill is gone.
       Color comes from the slot palette: white for regular slots, coffee in
       AB/group context. */
    height: 2px;
    top: -4px;
    margin: 0;
    z-index: 4;
    border-radius: 1px;
    background: var(--slot-pocket-edge);
    pointer-events: none;
}

.dz.top-overlay.split {
    width: calc(2 * 276px);
}

.dz.top-overlay.right {
    left: 276px;
}

/* the fade below the line went with the pocket pill (Gosta, round 6) */
.dz.top-overlay::after {
    content: none;
}

/* AB insertion lines sit 2px inside the dashed group boundary. The dashed
   ::after starts at -3px but ends at 40px inside a 41px cell, so mirrored
   visual spacing is top: 2px / bottom: 6px rather than equal CSS offsets.
   Keep all four ownership paths explicit. */
.chain-cell.dz-top.slot-before.ab-boundary-top > .dz.top-overlay {
    top: 2px;
}

.chain-cell.dz-bot.boundary-lower-group > .dz.bot-overlay {
    bottom: 6px;
}

.chain-cell.dz-top.slot-before.boundary-outer-bottom > .dz.top-overlay {
    top: 2px;
}

.dz.mid-overlay {
    display: none;
    z-index: 4;
    height: 37px;
    border-radius: 12px;
    /* Gosta (round 6): the drop ring is a 1px line inside the rectangle */
    outline: rgba(231, 232, 233, 0.92) solid 1px;
    outline-offset: -1px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
    pointer-events: none;
}

.dz.mid-overlay.split {
    width: calc(2 * 276px);
}

.dz.mid-overlay.right {
    left: 276px;
}

/* Slot pocket styles (insert before/after, gap pockets between adjacent groups) */
.chain-cell.dz-mid.slot-before > .dz.mid-overlay,
.chain-cell.dz-mid.slot-after > .dz.mid-overlay,
.chain-cell.dz-mid.slot-gap-before > .dz.mid-overlay,
.chain-cell.dz-mid.slot-gap-after > .dz.mid-overlay {
    /* Gosta (round 6): insert pockets are plain 2px lines like the mult
       lines — same weight everywhere, white in regular slots, coffee in
       AB/group context (the palette vars). Lines sit on the old pockets'
       centers, so the drop semantics read exactly where they used to. */
    outline: none;
    box-shadow: none;
    background: var(--slot-pocket-edge);
    height: 2px;
    border-radius: 1px;
    overflow: hidden;
}

.chain-cell.dz-mid.slot-before > .dz.mid-overlay {
    top: 22px;
}

.chain-cell.dz-mid.slot-after > .dz.mid-overlay {
    top: 16px;
}

/* gap lines hug the row edge: the old pill centers sat ON the cell
   boundary, which left the 2px line floating 3px off the row */
.chain-cell.dz-mid.slot-gap-before > .dz.mid-overlay {
    top: -3px;
}

.chain-cell.dz-mid.slot-gap-after > .dz.mid-overlay {
    top: calc(100% - 3px);
}

/* the rail highlights went with the pocket pills (Gosta, round 6) */
.chain-cell.dz-mid.slot-before > .dz.mid-overlay::before,
.chain-cell.dz-mid.slot-after > .dz.mid-overlay::after,
.chain-cell.dz-mid.slot-gap-before > .dz.mid-overlay::before,
.chain-cell.dz-mid.slot-gap-after > .dz.mid-overlay::before {
    content: none;
}

.dz.bot-overlay {
    display: none;
    position: absolute;
    /* same 2px line as every insert indicator (Gosta, round 6), centered
       where the old pocket pill sat */
    height: 2px;
    bottom: 8px;
    z-index: 4;
    border-radius: 1px;
    background: var(--slot-pocket-edge);
    pointer-events: none;
}

.chain-cell.dz-bot.ab-boundary-bottom > .dz.bot-overlay {
    bottom: 6px;
}

.dz.bot-overlay.right {
    left: 276px;
}

.dz.bot-overlay.split {
    width: calc(2 * 276px);
}

/* DND display selectors */
.dz-top.slot-before.left .dz.top.left ~ .dz.top-overlay.left,
.dz-top.slot-before.right .dz.top.right ~ .dz.top-overlay.right,
.dz-bot.slot-after.left .dz.bot.left ~ .dz.bot-overlay.left,
.dz-bot.slot-after.right .dz.bot.right ~ .dz.bot-overlay.right {
    display: block;
}

:is(
    .dz-mid.slot-before.left,
    .dz-mid.slot-after.left,
    .dz-mid.slot-gap-before.left,
    .dz-mid.slot-gap-after.left
) .dz.mid.left ~ .dz.mid-overlay.left,
:is(
    .dz-mid.slot-before.right,
    .dz-mid.slot-after.right,
    .dz-mid.slot-gap-before.right,
    .dz-mid.slot-gap-after.right
) .dz.mid.right ~ .dz.mid-overlay.right {
    display: block;
}

/* CHAIN LINKS */

.chain-mult-link {
    position: absolute;
    width: 36px;
    left: 288px;
    height:1px;
    top: 18.5px;
    border-top: 2px solid var(--black-90);
}

.chain-cell.split .chain-mult-link {
    width: 25px;
    left: 567px;
}

.chain-cell.split .chain-mult-link.thru {
    width: 36px;
    left: 556px;
}

.chain-mult-link.thru {
    width: 36px;
    left: 278px;
}

/* multed module block upstream of an M2S module */
.chain-mult-link.m2s {
    width: 304px;
    border-top: 2px solid var(--black-90);
    left: 288px;
}

.chain-cell-link {
    position: relative;
    width: 309px;
    height: 41px;
}

.chain-cell-link.right {
    width: calc(2px + 276px);
}

.chain-cell-link .link {
    position: absolute;
    width: 100%;
    height: 100%;

    top: -2px;
    left: -133px;

    border-right: 2px solid #e7d8d9;
    pointer-events: none;
}

.chain-cell-link .terminal { 
    position: absolute;
    width: 8px;
    height: 8px;

    left: 171px;
    bottom: 3px;

    border-right: 2px solid #e7d8d9;
    border-bottom: 2px solid #e7d8d9;
    transform: rotate(45deg);
}

.chain-cell-link.right .terminal { 
    left: 140px;
}

.chain-link {
    position: relative;
    width: 278px;
    /* height: 44px; */
    overflow: hidden;
    margin-left: 0px;
}

.chain-link .left {
    position: absolute;
    width: 100%;
    height: 29px;
    top: 18.5px;
    left: -139px;

    border-top: 2px solid #e7d8d9;
    border-top-right-radius: 10px;
    border-right: 2px solid #e7d8d9;
}

.chain-link.split.left .left {
    left: -139.5px;
}

.chain-link.split.left .right {
    left: -139.5px;
}

.chain-link .left.short {
    height: 26px;
}

.chain-link .left.thru {
    border-right: 0;
    border-top-right-radius: 0;
}

.chain-link .left.thru.tee {
    border-right: 2px solid #e7d8d9;
}

.chain-link.terminal .left {
    height: 22px;
}

.chain-link.split.right.terminal {
    width: 296px;
}

.chain-link.split.left .terminal {
    left: 133.5px;
}

.chain-link.split.left .icon {
    left: -43px;
}

.chain-link.split.right .vert {
    left: -138px;
}

.chain-link.split.right.terminal .vert {
    left: -156px;
}

.chain-link .icon {
    position: absolute;
    left: -35px;
    top: -2px;
    width: 100%;
    height: 100%;

    display: flex;
    color: black;
    justify-content: center;
    align-items: center;
}

.chain-link.split .icon {
    left: -6px;
}

.chain-link .icon .delete {
    width: 22px;
    height: 22px;

    visibility: hidden;

    color: black;
    font-size: 19px;
    font-weight: bolder;

    border-radius: 22px;
    background-color: var(--black-35);

    display: flex;
    justify-content: center;
    align-items: center;

    text-indent: 0.1rem;
    user-select: none; 
}

.chain-link .icon:hover .delete {
    visibility:visible;
    color:var(--hover-fg);
}

.chain-link.left .icon .delete {
    position: absolute;
    left: 162px;
}


.chain-link.split.right .icon .delete {
    position: absolute;
    left: 134px;
}

.chain-link.split.left .icon .delete {
    position: absolute;
    left: 170px;
}

.chain-link .thru {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 18.5px;
    border-top: 2px solid var(--black-90);
}

.chain-link .vert { 
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: -139.5px;
    border-right: 2px solid var(--black-90);
}

.chain-link .vert.short { 
    height: 48px;
}

.chain-link.split.left .vert {
    left: -139.5px;
}

.chain-link.split.right .left {
    left: -138.5px;
}

.chain-link .terminal { 
    position: absolute;
    width: 8px;
    height: 8px;
    left: 134px;
    bottom: 4px;
    border-right: 2px solid var(--black-90);
    border-bottom: 2px solid var(--black-90);
    transform: rotate(45deg);
}

.chain-link.terminal .vert { 
    top: -4px;
}

.chain-link.split.right { 
    margin-left: 0px;
}

.chain-link.split.right.terminal .left { 
    left: -156px;
}

.chain-link.split.right .thru { 
    margin-left: 0px;
}

.chain-link.split.right .terminal { 
    left: 134.5px;
}

.chain-card > .overlay {
    --chain-header-height: 72px;  /* 32px (.header) + 40px (.subheader) */

    position: absolute;
    top: var(--chain-header-height);
    left: 0;
    right: 0;
    bottom: 20px;  /* Stop before card padding */

    /* Transparent - click target only, visual overlay is on .chain-module.proc */
    background: transparent;
    z-index: 999;
}

/* Visual overlay only on processor modules when chain is bypassed */
.chain-card.bypassed .chain-module.proc::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #000000AA;
    border-radius: 2px;
    pointer-events: none;
}

.chain-card > .overlay > .content {
    position: absolute;
    border-radius: 6px;
    border: 1px solid var(--black-25);
    padding: 8px 14px;
    left: 50%;
    top: 50%;  /* JS will override this */
    transform: translate(-50%, -50%);
    background: var(--black-85);
}

.chain-card > .overlay > .content > h1 {
    color: var(--black-35);
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    text-align: center;
    margin: 0;
}

.chain-card > .overlay > .content > h2 {
    color: var(--black-45);
    text-align: center;
    font-size: 11px;
    font-style: italic;
    margin: 4px 0 0 0;
}

.chain-card > .overlay > .content em {
    color: var(--black-25);
    text-decoration-line: underline;
}

.chain-card {
    background-color: var(--black-05);
    padding-bottom: 20px;
    border-radius: 4px;
    margin-right: 26px;
    margin-bottom: 26px;
    z-index: 0;
    position: relative;
}

.chain-card:hover {
    outline: 1px solid var(--black-15);
}

.chain-card.highlight {
    outline: 1px solid var(--black-25);
    box-shadow: 0 0 3px var(--black-25);
}

.chain-card.drop-invalid {
    opacity: 50%;
}

/* Pin the top edge: collapsing a conflict spoiler shrinks the dialog upward
   from the bottom only, so the header stays under the pointer instead of the
   translate(-50%,-50%) recenter jumping it */
.modal.conflicts .dialog {
    top: 15%;
    transform: translateX(-50%);
}

.modal.conflicts .dialog .conflict {
    border: 2px solid var(--black-20);
    border-radius: 4px;
}

.modal.conflicts .dialog .conflict .header {
    position: relative;
    padding-top: 6px;
    padding-bottom: 6px;
    padding-left: 10px;

    border-top-left-radius: 4px;
    border-top-right-radius: 4px;

    background-color: var(--black-10);

    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal.conflicts .dialog .conflict .header .expand {
    font-size: 20px;
}

.modal.conflicts .dialog .conflict .header .chain {
    position: absolute;
    left: 32px;

    font-size: 15px;
    color: var(--black-80);
    font-weight: 500;
}

.modal.conflicts .dialog .conflict .header .score {
    position: absolute;
    right: 16px;

    font-size: 12px;
    color: var(--black-65);
}

.modal.conflicts .dialog .conflict .nodes {
    overflow: auto;
    padding: 10px;

    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;

    background-color: var(--black-00);
}

.modal.conflicts .dialog .conflict .nodes .node {
    padding-left: 10px;
}

.modal.conflicts .dialog .conflict .nodes .node:not(:last-child) {
    padding-bottom: 5px;
}

.modal.conflicts .dialog .message .choice:not(:last-child) {
    padding-bottom: 8px;
}

.modal.conflicts .dialog .conflict .nodes .node::before {
    font-family: 'Material Icons';
    font-size: 8px;
    content: 'circle';
    padding-right: 10px;
}

/* Delete affordance: custom cursor + red outline on cmd-held hover over a deletable surface.
   Red SVG stroke is --red-3 (#ec736a); keep it in sync with the outline below. The dark
   stroke is a contrast halo so the X reads on any background. */
body.cmd-held .chain-header.deletable > .header:hover,
body.cmd-held .chain-module.deletable:hover,
body.cmd-held .browser-device.deletable:hover {
    cursor: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 16 16, crosshair;
}
/* Force the delete cursor onto descendants too (e.g. the name box's text cursor would otherwise win). */
body.cmd-held .chain-header.deletable > .header:hover *,
body.cmd-held .chain-module.deletable:hover *,
body.cmd-held .browser-device.deletable:hover * {
    cursor: inherit;
}
/* Draw the chain-node overlay on its visible frame so source/destination and
   split-channel corner radii stay exact. Header/device surfaces own their
   visible background directly, so their overlays remain on the surface. */
body.cmd-held .chain-header.deletable > .header:hover::after,
body.cmd-held .chain-module.deletable:hover .frame::after,
body.cmd-held .browser-device.deletable:hover::after {
    content: '';
    position: absolute;
    inset: 0;
    border: 1.5px solid var(--red-3);
    border-radius: inherit;
    pointer-events: none;
    z-index: 100;
}

/* Isolate affordance: custom "+" cursor + green outline on alt-held hover over a node.
   Mirrors the delete affordance above but non-destructive (copy to a new chain). Green
   stroke is --green-1 (#49c97c); keep it in sync with the outline below. Applies to both
   in-chain nodes (.chain-module) and left-browser palette nodes (.isolatable items). */
body.alt-held .chain-module.isolatable:hover,
body.alt-held .item .isolatable:hover {
    cursor: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) 16 16, copy;
}
body.alt-held .chain-module.isolatable:hover *,
body.alt-held .item .isolatable:hover * {
    cursor: inherit;
}
/* Browser palette items aren't positioned by default; the ::after overlay needs a
   containing block. No offsets, so this doesn't shift layout. */
body.alt-held .item .isolatable:hover {
    position: relative;
}
body.alt-held .chain-module.isolatable:hover::after,
body.alt-held .item .isolatable:hover::after {
    content: '';
    position: absolute;
    inset: 0;
    border: 1.5px solid var(--green-1);
    border-radius: inherit;
    pointer-events: none;
    z-index: 100;
    box-shadow: 0 0 0 4px rgba(73, 201, 124, 0.15); /* --green-1 at 15% (rgba needed for alpha) */
}
`, "",{"version":3,"sources":["webpack://./src/chain.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;IACX;;;gDAG4C;IAC5C,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,oEAAoE;IACpE,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,6EAA6E;IAC7E,0FAA0F;IAC1F,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,oBAAoB;IACpB,0FAA0F;AAC9F;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;IAClC,oBAAoB;IACpB,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,WAAW;;IAEX,6BAA6B;IAC7B,iCAAiC;;IAEjC,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;;IAEjB,eAAe;IACf,gBAAgB;;IAEhB,mBAAmB;IACnB,gBAAgB;IAChB,4DAA4D;;IAE5D,cAAc;;IAEd,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;IACtB,iCAAiC;IACjC,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;AACA,yBAAyB,UAAU,EAAE;;AAErC;IACI,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iCAAiC;IACjC,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,uEAAuE;AACvE;IACI,aAAa;IACb,qCAAqC;IACrC,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,qEAAqE;AACrE;IACI,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,UAAU;;AAEd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,qEAAqE;IACrE,qBAAqB;IACrB,QAAQ;;IAER,YAAY;;IAEZ,aAAa;IACb,qBAAqB;IACrB,mBAAmB;;IAEnB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;;IAElB;4DACwD;IACxD,WAAW;IACX,YAAY;;IAEZ,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;IAC7B,iCAAiC;AACrC;;AAEA;iEACiE;AACjE;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA,qEAAqE;AACrE;;IAEI,uBAAuB;AAC3B;;AAEA;;;gBAGgB;AAChB;;IAEI,YAAY;AAChB;;AAEA;;IAEI,UAAU;AACd;;AAEA;sEACsE;AACtE;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;;IAEZ,eAAe;IACf,gBAAgB;IAChB,sBAAsB;;IAEtB,mBAAmB;IACnB,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;IACtB,iCAAiC;IACjC,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;AACnB;AACA,4BAA4B,UAAU,EAAE;;AAExC;IACI,eAAe;AACnB;;AAEA,kFAAkF;AAClF;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;oDACoD;AACpD;;;IAGI,YAAY;AAChB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ;6EACyE;IACzE,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,yEAAyE;IACzE,YAAY;IACZ,8CAA8C;IAC9C,eAAe;IACf,sBAAsB;;IAEtB,sBAAsB;IACtB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf;iDAC6C;IAC7C,oDAAoD;AACxD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,6DAA6D;IAC7D,eAAe;AACnB;;AAEA;IACI,gBAAgB;;IAEhB,eAAe;AACnB;;AAEA,gBAAgB;;AAEhB;IACI,kBAAkB;IAClB,YAAY;IACZ,kDAAkD;IAClD,YAAY;;IAEZ,sBAAsB;IACtB,kBAAkB;;IAElB,aAAa;IACb,iBAAiB;AACrB;;AAEA,2DAA2D;AAC3D;;;IAGI,iDAAiD;AACrD;;AAEA,uDAAuD;AACvD;;IAEI,aAAa;IACb,sCAAsC;AAC1C;;AAEA,iBAAiB;AACjB;IACI,OAAO;IACP,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;;IAE1B,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;;IAEnB,sBAAsB;IACtB,eAAe;IACf,mBAAmB;;IAEnB,kBAAkB;IAClB,sCAAsC;IACtC,2BAA2B;;IAE3B,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA,8BAA8B;AAC9B;IACI,2BAA2B;IAC3B,mCAAmC;IACnC,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,2BAA2B;IAC3B,iCAAiC;AACrC;AACA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;;IAEI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,uBAAuB;AAC3B;;AAEA,6BAA6B;AAC7B;IACI,2BAA2B;IAC3B,sBAAsB;AAC1B;AACA;IACI,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,sBAAsB;;IAEtB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;;IAEtB,mBAAmB;IACnB,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;;IAEI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;;IAEZ,eAAe;IACf,sBAAsB;;IAEtB,mBAAmB;IACnB,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,SAAS;;IAET,iCAAiC;;IAEjC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;;2BAG2B;AAC3B;IACI,uEAAuE;AAC3E;;AAEA;gFACgF;AAChF;IACI,uEAAuE;AAC3E;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;;IAEX,eAAe;IACf,kBAAkB;IAClB,sBAAsB;;IAEtB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;;IAEX,kBAAkB;IAClB,UAAU;;IAEV,eAAe;;IAEf,mBAAmB;;IAEnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;;IAEX,6BAA6B;IAC7B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,kEAAkE;IAClE,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;;IAEX,eAAe;IACf,gBAAgB;;IAEhB,sBAAsB;IACtB,iCAAiC;;IAEjC,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;;IAEvB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;0EAC0E;AAC1E;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;2EAC2E;AAC3E;IACI,MAAM;AACV;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA,cAAc;;AAEd;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,iBAAiB;;IAEjB,iCAAiC;;IAEjC,eAAe;IACf,iBAAiB;IACjB,sBAAsB;;IAEtB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;;IAEX,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;AACnC;;AAEA,aAAa;AACb;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB;;mDAE+C;AACnD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4CAA4C;IAC5C,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,8CAA8C;IAC9C,+CAA+C;IAC/C,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,6CAA6C;IAC7C,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA;IACI,gDAAgD;IAChD,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kCAAkC;IAClC,oBAAoB;AACxB;;AAEA;;;IAGI,sEAAsE;IACtE,kCAAkC;IAClC,oBAAoB;AACxB;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;;4EAE4E;AAC5E;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,4BAA4B;IAC5B,YAAY;IACZ,kCAAkC;IAClC,oBAAoB;IACpB,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kCAAkC,EAAE,0BAA0B;AAClE;;AAEA;IACI,kCAAkC,EAAE,yBAAyB;AACjE;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,YAAY;AAChB;;AAEA,WAAW;AACX;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA,gBAAgB;AAChB;IACI,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;CAEC,cAAc;AACf;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,UAAU;AACV;IACI,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA,UAAU;AACV;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,yBAAyB;IACzB,wBAAwB;IACxB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI;;uCAEmC;IACnC,6CAA6C;IAC7C,kBAAkB;IAClB,YAAY;IACZ,2DAA2D;IAC3D,YAAY;IACZ,iBAAiB;IACjB,aAAa;AACjB;;AAEA;;sCAEsC;AACtC;IACI,6CAA6C;AACjD;;AAEA;IACI,YAAY;AAChB;;AAEA,QAAQ;AACR;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB;;;0BAGsB;IACtB,WAAW;IACX,SAAS;IACT,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,mCAAmC;IACnC,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA,uEAAuE;AACvE;IACI,aAAa;AACjB;;AAEA;;;4CAG4C;AAC5C;IACI,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,sEAAsE;IACtE,4CAA4C;IAC5C,oBAAoB;IACpB,yCAAyC;IACzC,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA,kFAAkF;AAClF;;;;IAII;;;wEAGoE;IACpE,aAAa;IACb,gBAAgB;IAChB,mCAAmC;IACnC,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;+DAC+D;AAC/D;IACI,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;AAEA,oEAAoE;AACpE;;;;IAII,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB;sCACkC;IAClC,WAAW;IACX,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,mCAAmC;IACnC,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,0BAA0B;AAC1B;;;;IAII,cAAc;AAClB;;AAEA;;;;;;;;;;;;IAYI,cAAc;AAClB;;AAEA,gBAAgB;;AAEhB;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,UAAU;IACV,WAAW;IACX,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA,kDAAkD;AAClD;IACI,YAAY;IACZ,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;;IAEZ,SAAS;IACT,YAAY;;IAEZ,+BAA+B;IAC/B,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;;IAEX,WAAW;IACX,WAAW;;IAEX,+BAA+B;IAC/B,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;;IAEZ,6BAA6B;IAC7B,6BAA6B;IAC7B,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;;IAEZ,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,kBAAkB;;IAElB,YAAY;IACZ,eAAe;IACf,mBAAmB;;IAEnB,mBAAmB;IACnB,iCAAiC;;IAEjC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;;AAGA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,cAAc;IACd,uCAAuC;AAC3C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,WAAW;IACX,uCAAuC;IACvC,wCAAwC;IACxC,wBAAwB;AAC5B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B,GAAG,uCAAuC;;IAErE,kBAAkB;IAClB,+BAA+B;IAC/B,OAAO;IACP,QAAQ;IACR,YAAY,GAAG,6BAA6B;;IAE5C,6EAA6E;IAC7E,uBAAuB;IACvB,YAAY;AAChB;;AAEA,oEAAoE;AACpE;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iCAAiC;IACjC,iBAAiB;IACjB,SAAS;IACT,QAAQ,GAAG,0BAA0B;IACrC,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,iCAAiC;IACjC,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;AACvC;;AAEA;IACI,YAAY;AAChB;;AAEA;;6CAE6C;AAC7C;IACI,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;;IAElB,2BAA2B;IAC3B,4BAA4B;;IAE5B,iCAAiC;;IAEjC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;;IAEV,eAAe;IACf,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;;IAEX,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,aAAa;;IAEb,8BAA8B;IAC9B,+BAA+B;;IAE/B,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;;gEAEgE;AAChE;;;IAGI,gEAA+W;AACnX;AACA,wGAAwG;AACxG;;;IAGI,eAAe;AACnB;AACA;;0EAE0E;AAC1E;;;IAGI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,gCAAgC;IAChC,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;AAChB;;AAEA;;;uFAGuF;AACvF;;IAEI,2DAA8U;AAClV;AACA;;IAEI,eAAe;AACnB;AACA;gEACgE;AAChE;IACI,kBAAkB;AACtB;AACA;;IAEI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,kCAAkC;IAClC,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,8CAA8C,EAAE,6CAA6C;AACjG","sourcesContent":[".chain-space {\n    height: 100%;\n    width: 100%;\n    /* 1px left the first row's 1px outline flush with the scroll edge, where\n       fractional-DPR rounding clips it; the 2px vertical inset gives it\n       headroom. Horizontal content uses the same 20px frame as the header\n       CTA and device editor (Gosta, round 6). */\n    padding: 2px 20px;\n}\n\n.chain-space:not(.empty) {\n    overflow: auto;\n    display: flex;\n    flex-wrap: wrap;\n    align-content: start;\n    align-items: flex-start;\n}\n\n.chain-space.empty {\n    display: flex;\n    text-align: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.chain-space.empty .empty {\n    padding: 50px;\n    color: var(--black-45);\n    font-style: italic;\n}\n\n.chain-matrix {\n    display: flex;\n    width: fit-content;\n    margin-left: 34px;\n}\n\n.chain-box {\n    /* same 320px frame as browser rows: one left/right edge per panel */\n    position: relative;\n    display: flex;\n    height: 40px;\n    width: 320px;\n    align-items: center;\n    overflow: visible;\n    /* Figma user-color formula: 20% fill, 30% on hover (Colors page frame 492) */\n    background-color: color-mix(in srgb, var(--chain-color, var(--black-30)) 20%, transparent);\n    box-shadow: 0 0 4px var(--black-05);\n}\n\n.chain-box > .overlay {\n    position:absolute;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    height: 100%;\n    left: 50%;\n    top: 50%;\n    background: #000000AA;\n    z-index: 999;\n}\n\n.chain-box > .overlay > h1 {\n    color: var(--black-65);\n    font-size: 17px;\n    margin: 1px;\n    white-space: nowrap;\n    text-align: center;\n}\n\n.chain-box > .overlay > h2 {\n    color: var(--black-45);\n    margin: 0px;\n    font-size: 13px;\n    font-style: italic;\n    text-align: center;\n}\n\n.chain-box:hover {\n    outline: 1px solid var(--black-25);\n    outline-offset: -1px;\n    background-color: color-mix(in srgb, var(--chain-color, var(--black-30)) 30%, transparent);\n}\n\n.chain-box.hidden  {\n    background-color: var(--black-10);\n}\n\n.chain-box.highlight {\n    outline: 1px solid var(--black-35);\n    outline-offset: -1px;\n    box-shadow: 0 0 2px var(--black-35);\n}\n\n.chain-box .activate {\n    margin: 10px;\n    height: 16px;\n    width: 16px;\n}\n\n.chain-box .activate .button {\n    position: absolute;\n    border-radius: 18px;\n    border: 3px solid;\n    height: 18px;\n    width: 18px;\n\n    border-color: var(--black-30);\n    background-color: var(--black-00);\n\n    user-select: none; \n}\n\n.chain-box .activate .button.invalid::before {\n    color: var(--black-30);\n    position: relative;\n    bottom: 8px;\n    left: -8px;\n    font-size: 28px;\n    font-weight: bold;\n    content: 'remove';\n    font-family: 'Material Icons';\n}\n\n.chain-box .activate .button.invalid,\n.chain-box .activate:hover .button.invalid {\n    filter: none;\n}\n\n.chain-box .name {\n    position: relative;\n    width: 150px;\n    letter-spacing: 0;\n\n    font-size: 13px;\n    font-weight: 500;\n\n    white-space: nowrap;\n    overflow: hidden;\n    mask: linear-gradient(to right, black 80%, transparent 100%);\n\n    line-height: 2;\n\n    user-select: none; \n}\n\n.chain-box .name.edit {\n    background-color: var(--black_10);\n    color: var(--black-80);\n    border: var(--black-80) solid 1px;\n    padding-left: 2px;\n    padding-right: 2px;\n    text-overflow: clip;\n    mask: none;\n}\n\n.chain-box .hide {\n    position: absolute;\n    right: 108px;\n    color: var(--black-35);\n}\n\n.chain-box .normal {\n    position: absolute;\n    right: 68px;\n    font-size: 23px;\n    color: var(--black-35);\n}\n\n.chain-box .normal.active {\n    font-weight: bold;\n}\n\n.chain-box .fave {\n    font-size: 24px;\n    position: absolute;\n    right: 32px;\n    color: var(--black-35);\n}\n\n.chain-box .lock {\n    font-size: 16px;\n    margin-left: 4px;\n    opacity: 0.7;\n    cursor: pointer;\n}\n.chain-box .lock:hover { opacity: 1; }\n\n.chain-box .popup {\n    position: absolute;\n    right: 1%;\n    font-size: 22px;\n    top: 7px;\n}\n\n.chain-box .div {\n    position: absolute;\n    right: 97px;\n    background-color: var(--black-35);\n    top: 7px;\n    height: 26px;\n    width: 1px;\n    opacity: 30%;\n}\n\n.color-picker {\n    border-top: 2px solid var(--black-30);\n    height: auto;\n    padding-top: 12px;\n    margin-bottom: 6px;\n}\n\n/* Even 4-per-row distribution across the menu width, no trailing gap */\n.color-picker .swatches {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    justify-items: center;\n    row-gap: 12px;\n}\n\n.color-picker .swatch {\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    cursor: pointer;\n    transition: transform 100ms ease;\n}\n\n.color-picker .swatch:hover {\n    transform: scale(1.15);\n}\n\n/* Selection = neutral outline ring around the (still round) swatch */\n.color-picker .swatch.selected {\n    outline: 2px solid var(--black-85);\n    outline-offset: 2px;\n}\n\n.chain-header {\n    position: relative;\n    align-items: center;\n    width: 100%;\n    user-select: none;\n    font-size: 24px;\n    z-index: 1;\n\n}\n\n.chain-header .header {\n    position: relative;\n    width: 100%;\n    /* Figma chain header: 12px left, 8px right, 4px gap (node 16:1542) */\n    padding: 0 8px 0 12px;\n    gap: 4px;\n\n    height: 32px;\n\n    display: flex;\n    justify-content: left;\n    align-items: center;\n\n    border-top-left-radius: 6px;\n    border-top-right-radius: 6px;\n}\n\n.chain-header.active .header {\n    color: var(--black-65);\n}\n\n.chain-header.muted .mutable {\n    filter: brightness(0.4);\n}\n\n.chain-header.muted .header .mutable:hover {\n    filter: brightness(0.8);\n}\n\n.chain-header .header .activate {\n    position: relative;\n\n    /* Figma bypass hit box is 28x28; centers the dot on the same 26px axis\n       as the subheader target icon (component 2307:65100) */\n    width: 28px;\n    height: 28px;\n\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n}\n\n.chain-header .header .activate .button {\n    height: 18px;\n    width: 18px;\n    border-radius: 18px;\n    border: 3px solid;\n    border-color: var(--black-30);\n    background-color: var(--black-00);\n}\n\n/* Center the 'remove' bar on the ring with flex instead of the old\n   hand-tuned bottom/left offsets that left it visibly off-axis */\n.chain-header .header .activate .button.invalid {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.chain-header .header .activate .button.invalid::before {\n    color: var(--black-30);\n    font-size: 28px;\n    font-weight: bold;\n    line-height: 1;\n    content: 'remove';\n    font-family: 'Material Icons';\n}\n\n.chain-header .header .activate .button.invalid,\n.chain-header .header .activate:hover .button.invalid {\n    filter: none;\n}\n\n.chain-header .header .activate .button.midi-learn::after {\n    height: 20px;\n    width: 20px;\n    border-radius: 16px;\n}\n\n/* An ON chain uses the same hover lift as other circular controls. */\n.chain-header .header .activate.active .button:hover,\n.chain-box.active .activate .button:not(.invalid):hover {\n    filter: brightness(1.3);\n}\n\n/* An OFF chain dims the ring to the same 60% as the header title, so it stops\n   reading as active. Ring stays brighter than the fill (Gosta, July 20).\n   Same treatment in the chain browser box, so the toggle looks identical in\n   both panels */\n.chain-header:not(.active) .header .activate .button:not(.invalid):not(.midi-learn),\n.chain-box.inactive .activate .button:not(.invalid):not(.midi-learn) {\n    opacity: 0.6;\n}\n\n.chain-header:not(.active) .header .activate:hover .button:not(.invalid):not(.midi-learn),\n.chain-box.inactive .activate:hover .button:not(.invalid):not(.midi-learn) {\n    opacity: 1;\n}\n\n/* 4px margin + 4px header gap = Figma's 8px bypass-to-name gap; the auto\n   right margin pushes the controls to the right edge (node 16:1542) */\n.chain-header .header .editable.name {\n    margin-left: 4px;\n    margin-right: auto;\n    min-width: 0;\n}\n\n.chain-header .header .editable.name  .name {\n    position: relative;\n    width: 236px;\n\n    font-size: 16px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n\n    white-space: nowrap;\n    overflow: hidden;\n    mask: linear-gradient(to right, black 70%, transparent 100%);\n}\n\n.chain-header .editable.name .name.edit {\n    background-color: var(--black_10);\n    color: var(--black-85);\n    border: var(--black-65) solid 1px;\n    padding-right: 2px;\n    text-overflow: clip;\n    mask: none;\n    opacity: 1;\n}\n\n.chain-header.split .header .editable.name  .name {\n    width: 480px;\n}\n\n.chain-header .lock {\n    font-size: 18px;\n    opacity: 0.7;\n    cursor: pointer;\n}\n.chain-header .lock:hover { opacity: 1; }\n\n.chain-header .minimize {\n    font-size: 24px;\n}\n\n/* Figma header controls: 24px glyph + 2px padding = 28px hit box (node 16:1542) */\n.chain-header .header .acticon {\n    padding: 2px;\n}\n\n.chain-header .header .tridot {\n    line-height: 1;\n}\n\n/* Figma dims the inactive header to 60%; the active chain shows full color\n   (component 16:1542, active vs default variants) */\n.chain-header:not(.active) .header .editable.name .name:not(.edit),\n.chain-header:not(.active) .header .minimize,\n.chain-header:not(.active) .header .popup {\n    opacity: 0.6;\n}\n\n.chain-header .header .minimize:hover,\n.chain-header .header .popup:hover {\n    opacity: 1;\n}\n\n.chain-header .target {\n    opacity: 0.8;\n    /* center the 18px icon on the bypass toggle's axis (measured 433 in the\n       demo): subheader pads 12px, so 12 + 4 + 9 lands the centers together */\n    margin-left: 4px;\n    font-size: 24px;\n    color: var(--black-35);\n}\n\n.chain-header .acticon.selected {\n    color: var(--hover-fg);\n}\n\n.chain-header .subheader {\n    width: 100%;\n    /* Figma subheader: 24px icons + 8px vertical padding (node 3463:60728) */\n    height: 40px;\n    /* Figma subheader padding (node 3463:60728) */\n    padding: 0 12px;\n    box-sizing: border-box;\n\n    color: var(--black-35);\n    display: flex;\n    justify-content: space-between;\n}\n\n.chain-header .chain-tags {\n    margin-left: 34px;\n    margin-right: 16px;\n    margin-bottom: 12px;\n}\n\n.chain-header .subheader > .left {\n    display: flex;\n    text-align: center;\n    justify-content: left;\n    align-items: center;\n}\n\n.chain-header .subheader > .right {\n    display: flex;\n    text-align: center;\n    justify-content: right;\n    align-items: center;\n}\n\n.chain-header .normal {\n    font-size: 24px;\n    /* Figma \"N\" glyph is Roboto Condensed (node 3463:60728); falls back to Inter\n       until the font ships in fonts/gfonts.css */\n    font-family: 'Roboto Condensed', 'Inter', sans-serif;\n}\n\n.chain-header .normal.active {\n    font-weight: bold;\n}\n\n.chain-header .notes {\n    margin-left: 14px;\n}\n\n.chain-header .subheader .tags {\n    margin-left: 8px;\n    /* Figma sell glyph is 20px, the other subheader icons 24px */\n    font-size: 20px;\n}\n\n.chain-header .fave {\n    margin-left: 8px;\n\n    font-size: 24px;\n}\n\n/* CHAIN BLOCK */\n\n.chain-module {\n    position: relative;\n    width: 276px;\n    /* Figma chain slot block is 37px (node 16:1665) */\n    height: 37px;\n\n    color: var(--black-85);\n    border-radius: 2px;\n\n    display: flex;\n    user-select: none;\n}\n\n/* Smooth transitions for dimming when overlay is visible */\n.chain-module .frame,\n.chain-module .tab,\n.chain-module > * {\n    transition: opacity 120ms ease, filter 120ms ease;\n}\n\n/* Dim underlying content while keeping overlay crisp */\n.chain-module.overlay > *:not(.portid),\n.browser-module.overlay > *:not(.portid) {\n    opacity: 0.55;\n    filter: saturate(0.7) brightness(0.95);\n}\n\n/* PortID badge */\n.portid {\n    top: 0%;\n    right: 54px;\n    padding: 3px;\n    padding-right: 5px;\n    transform: translateY(32%);\n\n    display: flex;\n    position: absolute;\n    justify-content: center;\n    align-items: center;\n\n    color: var(--black-00);\n    font-size: 12px;\n    white-space: nowrap;\n\n    border-radius: 6px;\n    box-shadow: 0 1px 2px rgba(0,0,0,0.25);\n    background: var(--black-15);\n\n    pointer-events: none;\n    z-index: 2;\n}\n\n.right > .portid {\n    right: 51px;\n}\n\n.conjoined .portid {\n    right: 80px;\n}\n\n.stereo .portid  {\n    right: 100px;\n}\n\n.m2s .portid {\n    right: 70px;\n}\n\n/* PorID badge role-specific */\n.portid.dest { \n    background: var(--black-00);\n    border: 0.8px solid var(--black-65);\n    color: var(--black-80);\n    padding-bottom: 4px;\n    padding-top: 4px;\n}\n.portid.source {\n    background: var(--black-80);\n    border: 2px solid var(--black-05);\n}\n.portid.proc {\n    transform: translateY(22%);\n    background: var(--black-35);\n    padding-bottom: 6px;\n    padding-top: 6px;\n}\n\n/* PortID token */\n.portid.proc .in,\n.portid.proc .out {\n    margin: 0 3px;\n    padding: 0 2px;\n    border-radius: 3px;\n    border: none;\n    background: transparent;\n}\n\n.portid div {\n    margin: 0px;\n    margin-left: 2px;\n    padding: 0px;\n    border: none;\n    background: transparent;\n}\n\n/* PortID polarity-specific */\n.portid.proc .in {\n    background: var(--black-85);\n    color: var(--black-00);\n}\n.portid.proc .out {\n    background: var(--black-00);\n    color: var(--black-80);\n}\n\n.chain-module .device  {\n    position: absolute;\n    left: 14.5px;\n    top: 3px;\n    width: 210px;\n    letter-spacing: 0.02em;\n\n    font-size: 13px;\n    font-weight: 700;\n    color: var(--black-80);\n\n    white-space: nowrap;\n    overflow: hidden;\n    mask: linear-gradient(to right, black 80%, transparent 100%);\n}\n\n.chain-module.invalid .device,\n.chain-module.invalid .name {\n    font-style: italic;\n    color: var(--black-45);\n}\n\n.chain-module.stereo .device,\n.chain-module.m2s .device {\n    width: 190px;\n}\n\n.chain-module.conjoined .device {\n    width: 240px;\n}\n\n.chain-module .name {\n    position: absolute;\n    bottom: 3px;\n    left: 15px;\n    width: 210px;\n\n    font-size: 13px;\n    color: var(--black-80);\n\n    white-space: nowrap;\n    overflow: hidden;\n    mask: linear-gradient(to right, black 80%, transparent 100%);\n}\n\n.chain-module.conjoined .name {\n    width: 240px;\n}\n\n.chain-module.stereo .name {\n    width: 190px;\n}\n\n.chain-module.m2s .name {\n    width: 205px;\n}\n\n.chain-module .frame {\n    position: absolute;\n    height: 100%;\n    width: 276px;\n    left: 0px;\n\n    background-color: var(--black-25);\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n/* A node in a chain is picked up and dropped, so it reacts to the pointer. The\n   module itself has no background, the frame paints it. Scoped to .chain-cell:\n   the same markup illustrates a device's shape in the configuration panel,\n   where it is read-only. */\n.chain-cell .chain-module:hover .frame {\n    background-image: linear-gradient(var(--hover-veil), var(--hover-veil));\n}\n\n/* A conjoined stereo node is rendered as two modules in a split cell, but both\n   halves are dragged as one item. Hover either rendered half as one node too. */\n.chain-cell.split:has(.chain-module.conjoined:hover) .chain-module.conjoined .frame {\n    background-image: linear-gradient(var(--hover-veil), var(--hover-veil));\n}\n\n.chain-module.invalid .frame {\n    background: var(--red-1);\n}\n\n.chain-module.ineligible {\n    color: var(--black-45);\n    opacity: 30%;\n}\n\n.chain-card.drop-invalid .chain-module .frame {\n    color: var(--black-45);\n}\n\n.chain-module .stub {\n    width: 100%;\n\n    font-size: 13px;\n    font-style: italic;\n    color: var(--black-45);\n\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n    user-select: none;\n}\n\n.chain-module .bypass {\n    height: 18px;\n    width: 18px;\n\n    position: absolute;\n    left: 10px;\n\n    font-size: 22px;\n\n    border-radius: 16px;\n\n    cursor: pointer;\n    user-select: none; \n}\n\n.chain-module.inactive .bypass {\n    height: 18px;\n    width: 18px;\n\n    border-color: var(--black-80);\n    border-radius: 10px;\n    border-width: 3px;\n}\n\n.chain-module .popup {\n    position: absolute;\n    right: 1px;\n    top: 6px;\n    font-size: 22px;\n}\n\n.chain-module .channel {\n    /* Figma channel badge is a 22px circle, 12px bold (node 16:615) */\n    border-radius: 22px;\n    position: absolute;\n    height: 22px;\n    width: 22px;\n    right: 24px;\n\n    font-size: 12px;\n    font-weight: 700;\n\n    color: var(--black-85);\n    background-color: var(--black-35);\n\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n    box-shadow: 0 0 2px var(--black-05);\n}\n\n.chain-module .channel.inactive {\n    color: var(--black-65);\n    background-color: var(--black-20);\n    font-weight: 500;\n}\n\n/* Only the bypass toggle reacts. The same .channel markup renders a read-only\n   mono/stereo badge in the device configuration, which must stay inert. */\n.chain-module .channel.acticon:hover {\n    filter: brightness(1.3);\n}\n\n.chain-module .channel.bypassed {\n    color: var(--black-05);\n    background-color: var(--black-45);\n    font-weight: 500;\n}\n\n.chain-module .channel.stereo.L {\n    right: 51px;\n}\n\n.chain-module .channel.m2s {\n    font-size: 12.5px;\n    width: 42px;\n}\n\n/* the chain header's 24px line box already seats the ink on center — undo\n   the global .tridot ink nudge there (it is tuned for 22.8px line boxes) */\n.chain-header .header .tridot {\n    top: 0;\n}\n\n.chain-module.selected .frame {\n    outline-color: var(--black-65);\n    outline-width: 1px;\n    outline-offset: -1px;\n    outline-style: solid;\n}\n\n/* AB groups */\n\n.chain-module.grouped .tab {\n    position: relative;\n    height: 100%;\n    width: 20px;\n    left: -24px;\n    padding-left: 1px;\n\n    background-color: var(--black-25);\n\n    font-size: 16px;\n    font-weight: bold;\n    color: var(--black-65);\n\n    cursor: pointer;\n    user-select: none;\n}\n\n.chain-module.grouped .tab > .index {\n    height: 100%;\n    width: 100%;\n\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.chain-module.grouped .tab > .index.midi-learn::after {\n    height: 110%;\n    width: 120%;\n}\n\n.chain-module.grouped .tab.active {\n    color: var(--black-05);\n    background-color: var(--black-45);\n}\n\n.chain-module.grouped .tab.bypassed {\n    color: var(--black-05);\n    background-color: var(--black-30);\n}\n\n.chain-module.grouped.top .tab {\n    border-top-left-radius: 12px;\n}\n\n.chain-module.grouped.top .tab > .index {\n    border-top-left-radius: 12px;\n}\n\n.chain-module.grouped.top .tab > .index.midi-learn::after {\n    border-top-left-radius: 12px;\n}\n\n.chain-module.grouped.bottom .tab {\n    border-bottom-left-radius: 12px;\n}\n\n.chain-module.grouped.bottom .tab > .index {\n    border-bottom-left-radius: 12px;\n}\n\n.chain-module.grouped.bottom .tab > .index.midi-learn::after {\n    border-bottom-left-radius: 12px;\n}\n\n/* PROC TAB */\n.chain-module.grouped.proc .tab { \n    background-color: var(--node-bg);\n}\n\n.chain-module.grouped.proc .tab.active {\n    background-color: var(--black-45);\n}\n\n.chain-module.grouped.proc .tab.bypassed {\n    background-color: var(--black-30);\n}\n\n.chain-module.grouped.ab-focus .frame {\n    background-color: #7a746b;\n    box-shadow:\n        inset 0 0 0 1px rgba(237, 226, 209, 0.12),\n        inset 0 0 0 999px rgba(205, 181, 145, 0.05);\n}\n\n.chain-module.grouped.ab-focus .tab {\n    background-color: #877968;\n}\n\n.chain-module.grouped.ab-focus::after {\n    --ab-focus-border: rgba(216, 194, 162, 0.44);\n    content: '';\n    position: absolute;\n    left: -27px;\n    top: -3px;\n    width: 302px;\n    height: 41px;\n    border-left: 2px dashed var(--ab-focus-border);\n    border-right: 2px dashed var(--ab-focus-border);  \n    pointer-events: none;\n    z-index: 2;\n}\n\n.chain-module.grouped.ab-focus.top::after {\n    border-top: 2px dashed var(--ab-focus-border);\n    border-top-left-radius: 14px;\n    border-top-right-radius: 4px;\n}\n\n.chain-module.grouped.ab-focus.bottom::after {\n    border-bottom: 2px dashed var(--ab-focus-border);\n    border-bottom-left-radius: 14px;\n    border-bottom-right-radius: 4px;\n}\n\n.chain-module.source.grouped.ab-focus.top::after {\n    border-top-right-radius: 14px;\n}\n\n.chain-module.dest.grouped.ab-focus.bottom::after {\n    border-bottom-right-radius: 14px;\n}\n\n.chain-module.grouped.ab-focus.left::after {\n    width: 581px;\n}\n\n.chain-module.grouped.ab-focus.right::after {\n    content: none;\n}\n\n.chain-cell:not(.split).replace-outline .chain-module .frame {\n    outline: 1px solid var(--black-90);\n    outline-offset: -1px;\n}\n\n.chain-module.grouped.replace-target .frame,\n.chain-cell.split.replace-outline.replace-channel.left .chain-module.left .frame,\n.chain-cell.split.replace-outline.replace-channel.right .chain-module.right .frame {\n    /* Gosta (round 6): the drop ring is a 1px line inside the rectangle */\n    outline: 1px solid var(--black-90);\n    outline-offset: -1px;\n}\n\n.chain-module.grouped.replace-target .frame.left,\n.chain-cell.split.replace-outline.replace-channel.left .chain-module.left .frame.left {\n    clip-path: inset(-2px 0 -2px -2px);\n}\n\n.chain-module.grouped.replace-target .frame.right,\n.chain-cell.split.replace-outline.replace-channel.right .chain-module.right .frame.right {\n    clip-path: inset(-2px -2px -2px 0);\n}\n\n/* A whole split replacement is one visual target. Drawing outlines on both\n   child frames exposes their internal seam (and clipping those frames also\n   clips their backgrounds), so use one non-destructive overlay rectangle. */\n.chain-cell.split.replace-outline:not(.replace-channel)::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: calc(2 * 276px + 3px);\n    height: 37px;\n    outline: 1px solid var(--black-90);\n    outline-offset: -1px;\n    pointer-events: none;\n    z-index: 4;\n}\n\n.chain-module.dragging .frame {\n    box-shadow: 0 0 8px rgba(0,0,0,0.4);\n}\n\n.chain-module.dragging.conjoined .frame.left {\n    clip-path: inset(-8px 0 -8px -8px); /* clips right side only */\n}\n\n.chain-module.dragging.conjoined .frame.right {\n    clip-path: inset(-8px -8px -8px 0); /* clips left side only */\n}\n\n.chain-module.conjoined .frame.right .buffer {\n    width: 65%;\n    position: absolute;\n    left: 0px;\n    height: 100%;\n}\n\n/* SOURCE */\n.chain-module.source .frame {\n    border-top-left-radius: 12px;\n    border-top-right-radius: 12px;\n}\n\n.chain-module.stub .frame {\n    background-color: var(--black-10);\n}\n\n.chain-module.stub.proc .frame {\n    background-color:  var(--black-10);\n}\n\n.chain-module.source.grouped .frame {\n    border-radius: 0;\n}\n\n.chain-module.source.grouped.top .frame {\n    border-top-right-radius: 12px;\n}\n\n/* DESTINATION */\n.chain-module.dest .frame {\n    border-bottom-left-radius: 12px;\n    border-bottom-right-radius: 12px;\n}\n\n.chain-module.dest.grouped .frame {\n    border-radius: 0;\n}\n\n.chain-module.dest.grouped.bottom .frame {\n    border-bottom-right-radius: 12px;\n}\n\n.chain-module.dest.grouped.bottom.left .frame {\n    border-bottom-right-radius: 0px;\n}\n\n /* PROCESSOR */\n.chain-module.proc .frame {\n    background-color: var(--node-bg);\n    border-radius: 0;\n}\n\n.chain-module.proc.invalid .frame {\n    background: var(--red-1);\n}\n\n/* SPLIT */\n.chain-module.left .frame {\n    border-top-right-radius: 0px;\n    border-bottom-right-radius: 0px;\n}\n\n.chain-module.right .frame {\n    border-top-left-radius: 0px;\n    border-bottom-left-radius: 0px;\n    left: 2px;\n}\n\n.chain-module.right.conjoined .frame {\n    left: 0px;\n    width: 278px;\n}\n\n.chain-module.grouped.top.left .frame {\n    border-top-right-radius: 0px;\n    border-bottom-right-radius: 0px;\n}\n\n/* BLANK */\n.chain-blank {\n    width: 345px;\n    height: 52px;\n}\n\n.chain-cell-bridge {\n    position: relative;\n    left: 0px;\n    top: -2px;\n    width: calc(-1px + 276px);\n    height: calc(2px + 41px);\n    overflow:hidden;\n    display: flex;\n}\n\n.chain-cell-bridge .link {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 20.5px;\n    left: -133px;\n    border-radius: 12px;\n    border: 2px solid #e7d8d9;\n}\n\n.chain-cell-bridge .tee {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 20.5px;\n    border-top: 2px solid #e7d8d9;\n}\n\n.chain-cell-bridge .thru {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: -133px;\n    border-right: 2px solid #e7d8d9;\n}\n\n.chain-cell {\n    /* insert-line color, AB/group context: the coffee of the AB outlines\n       (Gosta, round 6). The old pocket-pill palette is gone — one variable\n       drives every insert indicator. */\n    --slot-pocket-edge: rgba(244, 208, 159, 0.88);\n    position: relative;\n    width: 314px;\n    /* Figma chain column: 37px slot + 4px gap (node 16:1664) */\n    height: 41px;\n    overflow: visible;\n    display: flex;\n}\n\n/* Gosta (round 6): the regular insert line is white like every other line\n   (mult lines, drag targets — #e7d8d9); only the AB/group context keeps the\n   coffee color above. Blue is gone. */\n.chain-cell.slot-outer {\n    --slot-pocket-edge: rgba(231, 216, 217, 0.92);\n}\n\n.chain-cell.split {\n    width: 592px;\n}\n\n/* DND */\n.chain-cell > .dz {\n    position: absolute;\n    z-index:3;\n    width: 276px;\n}\n\n.chain-cell > .dz.split {\n    width: calc(2 * 276px);\n}\n\n.dz.top {\n    position: absolute;\n    height: 20px;\n    top: -12px;\n}\n\n.dz.mid {\n    position: absolute;\n    top: 10px;\n    height: 26px;\n}\n\n.dz.bot {\n    position: absolute;\n    height: 20x;\n    bottom: -15px;\n}\n\n.dz.top-overlay {\n    display: none;\n    position: absolute;\n    /* Gosta (round 6): a plain line at the mult-line weight (2px, the value\n       that survives strong zoom-out) — the gradient pocket pill is gone.\n       Color comes from the slot palette: white for regular slots, coffee in\n       AB/group context. */\n    height: 2px;\n    top: -4px;\n    margin: 0;\n    z-index: 4;\n    border-radius: 1px;\n    background: var(--slot-pocket-edge);\n    pointer-events: none;\n}\n\n.dz.top-overlay.split {\n    width: calc(2 * 276px);\n}\n\n.dz.top-overlay.right {\n    left: 276px;\n}\n\n/* the fade below the line went with the pocket pill (Gosta, round 6) */\n.dz.top-overlay::after {\n    content: none;\n}\n\n/* AB insertion lines sit 2px inside the dashed group boundary. The dashed\n   ::after starts at -3px but ends at 40px inside a 41px cell, so mirrored\n   visual spacing is top: 2px / bottom: 6px rather than equal CSS offsets.\n   Keep all four ownership paths explicit. */\n.chain-cell.dz-top.slot-before.ab-boundary-top > .dz.top-overlay {\n    top: 2px;\n}\n\n.chain-cell.dz-bot.boundary-lower-group > .dz.bot-overlay {\n    bottom: 6px;\n}\n\n.chain-cell.dz-top.slot-before.boundary-outer-bottom > .dz.top-overlay {\n    top: 2px;\n}\n\n.dz.mid-overlay {\n    display: none;\n    z-index: 4;\n    height: 37px;\n    border-radius: 12px;\n    /* Gosta (round 6): the drop ring is a 1px line inside the rectangle */\n    outline: rgba(231, 232, 233, 0.92) solid 1px;\n    outline-offset: -1px;\n    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);\n    pointer-events: none;\n}\n\n.dz.mid-overlay.split {\n    width: calc(2 * 276px);\n}\n\n.dz.mid-overlay.right {\n    left: 276px;\n}\n\n/* Slot pocket styles (insert before/after, gap pockets between adjacent groups) */\n.chain-cell.dz-mid.slot-before > .dz.mid-overlay,\n.chain-cell.dz-mid.slot-after > .dz.mid-overlay,\n.chain-cell.dz-mid.slot-gap-before > .dz.mid-overlay,\n.chain-cell.dz-mid.slot-gap-after > .dz.mid-overlay {\n    /* Gosta (round 6): insert pockets are plain 2px lines like the mult\n       lines — same weight everywhere, white in regular slots, coffee in\n       AB/group context (the palette vars). Lines sit on the old pockets'\n       centers, so the drop semantics read exactly where they used to. */\n    outline: none;\n    box-shadow: none;\n    background: var(--slot-pocket-edge);\n    height: 2px;\n    border-radius: 1px;\n    overflow: hidden;\n}\n\n.chain-cell.dz-mid.slot-before > .dz.mid-overlay {\n    top: 22px;\n}\n\n.chain-cell.dz-mid.slot-after > .dz.mid-overlay {\n    top: 16px;\n}\n\n/* gap lines hug the row edge: the old pill centers sat ON the cell\n   boundary, which left the 2px line floating 3px off the row */\n.chain-cell.dz-mid.slot-gap-before > .dz.mid-overlay {\n    top: -3px;\n}\n\n.chain-cell.dz-mid.slot-gap-after > .dz.mid-overlay {\n    top: calc(100% - 3px);\n}\n\n/* the rail highlights went with the pocket pills (Gosta, round 6) */\n.chain-cell.dz-mid.slot-before > .dz.mid-overlay::before,\n.chain-cell.dz-mid.slot-after > .dz.mid-overlay::after,\n.chain-cell.dz-mid.slot-gap-before > .dz.mid-overlay::before,\n.chain-cell.dz-mid.slot-gap-after > .dz.mid-overlay::before {\n    content: none;\n}\n\n.dz.bot-overlay {\n    display: none;\n    position: absolute;\n    /* same 2px line as every insert indicator (Gosta, round 6), centered\n       where the old pocket pill sat */\n    height: 2px;\n    bottom: 8px;\n    z-index: 4;\n    border-radius: 1px;\n    background: var(--slot-pocket-edge);\n    pointer-events: none;\n}\n\n.chain-cell.dz-bot.ab-boundary-bottom > .dz.bot-overlay {\n    bottom: 6px;\n}\n\n.dz.bot-overlay.right {\n    left: 276px;\n}\n\n.dz.bot-overlay.split {\n    width: calc(2 * 276px);\n}\n\n/* DND display selectors */\n.dz-top.slot-before.left .dz.top.left ~ .dz.top-overlay.left,\n.dz-top.slot-before.right .dz.top.right ~ .dz.top-overlay.right,\n.dz-bot.slot-after.left .dz.bot.left ~ .dz.bot-overlay.left,\n.dz-bot.slot-after.right .dz.bot.right ~ .dz.bot-overlay.right {\n    display: block;\n}\n\n:is(\n    .dz-mid.slot-before.left,\n    .dz-mid.slot-after.left,\n    .dz-mid.slot-gap-before.left,\n    .dz-mid.slot-gap-after.left\n) .dz.mid.left ~ .dz.mid-overlay.left,\n:is(\n    .dz-mid.slot-before.right,\n    .dz-mid.slot-after.right,\n    .dz-mid.slot-gap-before.right,\n    .dz-mid.slot-gap-after.right\n) .dz.mid.right ~ .dz.mid-overlay.right {\n    display: block;\n}\n\n/* CHAIN LINKS */\n\n.chain-mult-link {\n    position: absolute;\n    width: 36px;\n    left: 288px;\n    height:1px;\n    top: 18.5px;\n    border-top: 2px solid var(--black-90);\n}\n\n.chain-cell.split .chain-mult-link {\n    width: 25px;\n    left: 567px;\n}\n\n.chain-cell.split .chain-mult-link.thru {\n    width: 36px;\n    left: 556px;\n}\n\n.chain-mult-link.thru {\n    width: 36px;\n    left: 278px;\n}\n\n/* multed module block upstream of an M2S module */\n.chain-mult-link.m2s {\n    width: 304px;\n    border-top: 2px solid var(--black-90);\n    left: 288px;\n}\n\n.chain-cell-link {\n    position: relative;\n    width: 309px;\n    height: 41px;\n}\n\n.chain-cell-link.right {\n    width: calc(2px + 276px);\n}\n\n.chain-cell-link .link {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n\n    top: -2px;\n    left: -133px;\n\n    border-right: 2px solid #e7d8d9;\n    pointer-events: none;\n}\n\n.chain-cell-link .terminal { \n    position: absolute;\n    width: 8px;\n    height: 8px;\n\n    left: 171px;\n    bottom: 3px;\n\n    border-right: 2px solid #e7d8d9;\n    border-bottom: 2px solid #e7d8d9;\n    transform: rotate(45deg);\n}\n\n.chain-cell-link.right .terminal { \n    left: 140px;\n}\n\n.chain-link {\n    position: relative;\n    width: 278px;\n    /* height: 44px; */\n    overflow: hidden;\n    margin-left: 0px;\n}\n\n.chain-link .left {\n    position: absolute;\n    width: 100%;\n    height: 29px;\n    top: 18.5px;\n    left: -139px;\n\n    border-top: 2px solid #e7d8d9;\n    border-top-right-radius: 10px;\n    border-right: 2px solid #e7d8d9;\n}\n\n.chain-link.split.left .left {\n    left: -139.5px;\n}\n\n.chain-link.split.left .right {\n    left: -139.5px;\n}\n\n.chain-link .left.short {\n    height: 26px;\n}\n\n.chain-link .left.thru {\n    border-right: 0;\n    border-top-right-radius: 0;\n}\n\n.chain-link .left.thru.tee {\n    border-right: 2px solid #e7d8d9;\n}\n\n.chain-link.terminal .left {\n    height: 22px;\n}\n\n.chain-link.split.right.terminal {\n    width: 296px;\n}\n\n.chain-link.split.left .terminal {\n    left: 133.5px;\n}\n\n.chain-link.split.left .icon {\n    left: -43px;\n}\n\n.chain-link.split.right .vert {\n    left: -138px;\n}\n\n.chain-link.split.right.terminal .vert {\n    left: -156px;\n}\n\n.chain-link .icon {\n    position: absolute;\n    left: -35px;\n    top: -2px;\n    width: 100%;\n    height: 100%;\n\n    display: flex;\n    color: black;\n    justify-content: center;\n    align-items: center;\n}\n\n.chain-link.split .icon {\n    left: -6px;\n}\n\n.chain-link .icon .delete {\n    width: 22px;\n    height: 22px;\n\n    visibility: hidden;\n\n    color: black;\n    font-size: 19px;\n    font-weight: bolder;\n\n    border-radius: 22px;\n    background-color: var(--black-35);\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    text-indent: 0.1rem;\n    user-select: none; \n}\n\n.chain-link .icon:hover .delete {\n    visibility:visible;\n    color:var(--hover-fg);\n}\n\n.chain-link.left .icon .delete {\n    position: absolute;\n    left: 162px;\n}\n\n\n.chain-link.split.right .icon .delete {\n    position: absolute;\n    left: 134px;\n}\n\n.chain-link.split.left .icon .delete {\n    position: absolute;\n    left: 170px;\n}\n\n.chain-link .thru {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 18.5px;\n    border-top: 2px solid var(--black-90);\n}\n\n.chain-link .vert { \n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0px;\n    left: -139.5px;\n    border-right: 2px solid var(--black-90);\n}\n\n.chain-link .vert.short { \n    height: 48px;\n}\n\n.chain-link.split.left .vert {\n    left: -139.5px;\n}\n\n.chain-link.split.right .left {\n    left: -138.5px;\n}\n\n.chain-link .terminal { \n    position: absolute;\n    width: 8px;\n    height: 8px;\n    left: 134px;\n    bottom: 4px;\n    border-right: 2px solid var(--black-90);\n    border-bottom: 2px solid var(--black-90);\n    transform: rotate(45deg);\n}\n\n.chain-link.terminal .vert { \n    top: -4px;\n}\n\n.chain-link.split.right { \n    margin-left: 0px;\n}\n\n.chain-link.split.right.terminal .left { \n    left: -156px;\n}\n\n.chain-link.split.right .thru { \n    margin-left: 0px;\n}\n\n.chain-link.split.right .terminal { \n    left: 134.5px;\n}\n\n.chain-card > .overlay {\n    --chain-header-height: 72px;  /* 32px (.header) + 40px (.subheader) */\n\n    position: absolute;\n    top: var(--chain-header-height);\n    left: 0;\n    right: 0;\n    bottom: 20px;  /* Stop before card padding */\n\n    /* Transparent - click target only, visual overlay is on .chain-module.proc */\n    background: transparent;\n    z-index: 999;\n}\n\n/* Visual overlay only on processor modules when chain is bypassed */\n.chain-card.bypassed .chain-module.proc::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: #000000AA;\n    border-radius: 2px;\n    pointer-events: none;\n}\n\n.chain-card > .overlay > .content {\n    position: absolute;\n    border-radius: 6px;\n    border: 1px solid var(--black-25);\n    padding: 8px 14px;\n    left: 50%;\n    top: 50%;  /* JS will override this */\n    transform: translate(-50%, -50%);\n    background: var(--black-85);\n}\n\n.chain-card > .overlay > .content > h1 {\n    color: var(--black-35);\n    font-size: 14px;\n    font-weight: 600;\n    white-space: nowrap;\n    text-align: center;\n    margin: 0;\n}\n\n.chain-card > .overlay > .content > h2 {\n    color: var(--black-45);\n    text-align: center;\n    font-size: 11px;\n    font-style: italic;\n    margin: 4px 0 0 0;\n}\n\n.chain-card > .overlay > .content em {\n    color: var(--black-25);\n    text-decoration-line: underline;\n}\n\n.chain-card {\n    background-color: var(--black-05);\n    padding-bottom: 20px;\n    border-radius: 4px;\n    margin-right: 26px;\n    margin-bottom: 26px;\n    z-index: 0;\n    position: relative;\n}\n\n.chain-card:hover {\n    outline: 1px solid var(--black-15);\n}\n\n.chain-card.highlight {\n    outline: 1px solid var(--black-25);\n    box-shadow: 0 0 3px var(--black-25);\n}\n\n.chain-card.drop-invalid {\n    opacity: 50%;\n}\n\n/* Pin the top edge: collapsing a conflict spoiler shrinks the dialog upward\n   from the bottom only, so the header stays under the pointer instead of the\n   translate(-50%,-50%) recenter jumping it */\n.modal.conflicts .dialog {\n    top: 15%;\n    transform: translateX(-50%);\n}\n\n.modal.conflicts .dialog .conflict {\n    border: 2px solid var(--black-20);\n    border-radius: 4px;\n}\n\n.modal.conflicts .dialog .conflict .header {\n    position: relative;\n    padding-top: 6px;\n    padding-bottom: 6px;\n    padding-left: 10px;\n\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n\n    background-color: var(--black-10);\n\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.modal.conflicts .dialog .conflict .header .expand {\n    font-size: 20px;\n}\n\n.modal.conflicts .dialog .conflict .header .chain {\n    position: absolute;\n    left: 32px;\n\n    font-size: 15px;\n    color: var(--black-80);\n    font-weight: 500;\n}\n\n.modal.conflicts .dialog .conflict .header .score {\n    position: absolute;\n    right: 16px;\n\n    font-size: 12px;\n    color: var(--black-65);\n}\n\n.modal.conflicts .dialog .conflict .nodes {\n    overflow: auto;\n    padding: 10px;\n\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 4px;\n\n    background-color: var(--black-00);\n}\n\n.modal.conflicts .dialog .conflict .nodes .node {\n    padding-left: 10px;\n}\n\n.modal.conflicts .dialog .conflict .nodes .node:not(:last-child) {\n    padding-bottom: 5px;\n}\n\n.modal.conflicts .dialog .message .choice:not(:last-child) {\n    padding-bottom: 8px;\n}\n\n.modal.conflicts .dialog .conflict .nodes .node::before {\n    font-family: 'Material Icons';\n    font-size: 8px;\n    content: 'circle';\n    padding-right: 10px;\n}\n\n/* Delete affordance: custom cursor + red outline on cmd-held hover over a deletable surface.\n   Red SVG stroke is --red-3 (#ec736a); keep it in sync with the outline below. The dark\n   stroke is a contrast halo so the X reads on any background. */\nbody.cmd-held .chain-header.deletable > .header:hover,\nbody.cmd-held .chain-module.deletable:hover,\nbody.cmd-held .browser-device.deletable:hover {\n    cursor: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><path d=\"M8.5 8.5l15 15M23.5 8.5l-15 15\" stroke=\"%23090d11\" stroke-width=\"4.6\" stroke-linecap=\"round\" opacity=\"0.76\"/><path d=\"M8.5 8.5l15 15M23.5 8.5l-15 15\" stroke=\"%23ec736a\" stroke-width=\"2.45\" stroke-linecap=\"round\"/></svg>') 16 16, crosshair;\n}\n/* Force the delete cursor onto descendants too (e.g. the name box's text cursor would otherwise win). */\nbody.cmd-held .chain-header.deletable > .header:hover *,\nbody.cmd-held .chain-module.deletable:hover *,\nbody.cmd-held .browser-device.deletable:hover * {\n    cursor: inherit;\n}\n/* Draw the chain-node overlay on its visible frame so source/destination and\n   split-channel corner radii stay exact. Header/device surfaces own their\n   visible background directly, so their overlays remain on the surface. */\nbody.cmd-held .chain-header.deletable > .header:hover::after,\nbody.cmd-held .chain-module.deletable:hover .frame::after,\nbody.cmd-held .browser-device.deletable:hover::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    border: 1.5px solid var(--red-3);\n    border-radius: inherit;\n    pointer-events: none;\n    z-index: 100;\n}\n\n/* Isolate affordance: custom \"+\" cursor + green outline on alt-held hover over a node.\n   Mirrors the delete affordance above but non-destructive (copy to a new chain). Green\n   stroke is --green-1 (#49c97c); keep it in sync with the outline below. Applies to both\n   in-chain nodes (.chain-module) and left-browser palette nodes (.isolatable items). */\nbody.alt-held .chain-module.isolatable:hover,\nbody.alt-held .item .isolatable:hover {\n    cursor: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><path d=\"M16 7v18M7 16h18\" stroke=\"%23090d11\" stroke-width=\"4.6\" stroke-linecap=\"round\" opacity=\"0.76\"/><path d=\"M16 7v18M7 16h18\" stroke=\"%2349c97c\" stroke-width=\"2.45\" stroke-linecap=\"round\"/></svg>') 16 16, copy;\n}\nbody.alt-held .chain-module.isolatable:hover *,\nbody.alt-held .item .isolatable:hover * {\n    cursor: inherit;\n}\n/* Browser palette items aren't positioned by default; the ::after overlay needs a\n   containing block. No offsets, so this doesn't shift layout. */\nbody.alt-held .item .isolatable:hover {\n    position: relative;\n}\nbody.alt-held .chain-module.isolatable:hover::after,\nbody.alt-held .item .isolatable:hover::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    border: 1.5px solid var(--green-1);\n    border-radius: inherit;\n    pointer-events: none;\n    z-index: 100;\n    box-shadow: 0 0 0 4px rgba(73, 201, 124, 0.15); /* --green-1 at 15% (rgba needed for alpha) */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
